<template>
  <div class="my-committee-layout">
    <default-box
      :loader="loading"
      class="position-relative">

      <tables-slot
        :empty_spacer="loading"
        :pagination="[]"
        :empty_values="!employees?.length && !loading ? 'No loads available.' : ''">
        <template v-slot:table_head>
          <td class="w-0 text-nowrap">#</td>
          <td class="w-0 text-nowrap">{{ $t('user.name') }}</td>
          <td class="w-0 text-nowrap">{{ $t('user.committee') }}</td>
          <td class="w-0 text-nowrap">{{ $t('vacations.vacation_pending') }}</td>
        </template>
        <template v-slot:table_body>
          <tr v-for="employee in employees">
            <td class="w-0 text-nowrap">
              {{ employee.id }}
            </td>
            <td class="w-0 text-nowrap">
              {{ employee.name }}  {{ employee.surname }}
            </td>
            <td class="w-0 text-nowrap">
              {{ employee.committee_employee.title }}
            </td>
            <td class="w-0 text-nowrap">
              <template v-if="employee.vacations?.new_vacations">
                <div
                  v-for="(vacation, key) in employee.vacations.new_vacations"
                  :class="key ? 'mt-7' : ''"
                  class="d-flex align-items-center">
                  <div>
                    <b>{{$t('vacations.from')}}:</b> {{vacation.date_start}}
                  </div>
                  <div class="ml-5">
                    <b>{{$t('vacations.to')}}:</b> {{vacation.date_end}}
                  </div>
                  <default-button
                    class="ml-5"
                    button_small
                    @click="submitVacation(employee.id, vacation.dates, 1)">
                    {{ $t('vacations.submit_vacation') }}
                  </default-button>
                  <default-button
                    class="ml-5 btn_error"
                    button_small
                    @click="submitVacation(employee.id, vacation.dates, 0)">
                    {{ $t('vacations.refuse_vacation') }}
                  </default-button>
                </div>
              </template>
            </td>
          </tr>
        </template>
      </tables-slot>
    </default-box>
  </div>
</template>

<script>

import {axiosManager} from "../../helpers/axios_requests";
import BadgeBlock from "../slots/BadgeBlock";
import DefaultBox from "../slots/DefaultBox";
import DefaultTitle from "../small_components/DefaultTitle";
import TablesSlot from "../small_components/tables/TablesSlot";
import SearchInput from "../small_components/SearchInput";
import RouterLinkTo from "../small_components/RouterLinkTo";
import EditIcon from "../icons/EditIcon";
import routes_mixin from "../../mixins/routes_mixin";
import DefaultButton from "../small_components/DefaultButton";
import {FORMAT_ERROR_MESSAGE} from "../../helpers/validation_error_message";
import {STATUS_ERROR} from "../../store/modules/notifiocation";
import {mapActions} from "vuex";

export default {
  name: 'MyCommitteeLayout',
  mixins: [routes_mixin],
  components: {
    DefaultButton,
    EditIcon,
    RouterLinkTo,
    SearchInput,
    TablesSlot,
    DefaultTitle,
    DefaultBox,
    BadgeBlock

  },
  computed: {},
  data() {
    return {
      loading: false,
      search: '',
      employees: [],
    }
  },
  mounted() {
    this.fetchCommittee()
  },
  methods: {
    ...mapActions([
      'actionPushNotification'
    ]),
    async fetchCommittee() {
      this.loading = true
      axiosManager.fetchEmployees({year: (new Date).getFullYear()})
        .then(({data}) => {
          this.employees = data.employees
        })
        .finally(() => {
          this.loading = false
        })
    },
    submitVacation(user_id, dates = [], status = 0) {
      this.loading = true
      axiosManager.approveVacationByDates({
        user_id: user_id,
        dates: dates,
        status: status
      })
        .then(({data}) => {
          if (data.errors) {
            let message = FORMAT_ERROR_MESSAGE(data.errors)
            this.actionPushNotification(
                {message: message, status: STATUS_ERROR}
            )
            return;
          }
          this.fetchCommittee()
        })
        .catch(e => {
          this.loading = false
        })
    },
  }
}
</script>
